import axios from 'axios'
import jwtDecode from 'jwt-decode';
import React, { createContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom';



export const AuthContext = createContext(null)

export default function AuthContextProvider(props) {

    // const notify = (msg, type) => toast[type](msg);

    const [userToken, setUserToken] = useState(null);

    function logOut() {
        let token = localStorage.getItem('authorization')
        if (token !== null) {
            localStorage.removeItem('authorization');
            setUserToken(null);
            return <Navigate to='/login' />
        } else {
            // notify("You are not logged in", "error")
        }
    }

    const saveUserToken = () => {
        let encodedToken = localStorage.getItem('authorization');
        var decodedToken = jwtDecode(encodedToken);
        localStorage.setItem('decodedToken', decodedToken);
        setUserToken(decodedToken);
        // console.log(decodedToken);
    }

    useEffect(() => {
        if (localStorage.getItem('authorization') !== null) {
            saveUserToken();
        }
    }, [])

    if (userToken) {
        var _id = userToken._id
    }

    return (
        <AuthContext.Provider value={{ saveUserToken, userToken, logOut, _id }} >
            {props.children}
        </AuthContext.Provider>
    )
}
